import instance from 'api';
import { IDynamicTableParams } from 'components/DynamicTable';
import { IAvailableColumnModel, IAvailableGroupColumnModel } from 'interfaces';
import { IServiceType } from './interfaces';

export const getServiceTypeList = (data: IDynamicTableParams) => {
  return instance()
    .post<IServiceType[]>(`/serviceType/list`, data)
    .then((response) => response.data);
};

export const getServiceTypeAvailableColumns = () => {
  return instance()
    .post<IAvailableColumnModel[]>(`/serviceType/availableColumns`)
    .then((response) => response.data);
};

export const getServiceTypeAvailableGroupColumns = () => {
  return instance()
    .post<IAvailableGroupColumnModel[]>(`/serviceType/availableGroupColumns`)
    .then((response) => response.data);
};

export const loadServiceType = (serviceTypeId: number) => {
  return instance()
    .get<IServiceType>(`/serviceType/${serviceTypeId}/load/`)
    .then((response) => response.data);
};

export const createServiceType = (serviceType: IServiceType) => {
  return instance()
    .post<IServiceType>('/serviceType/save', serviceType)
    .then((response) => response.data);
};

export const updateServiceType = (serviceType: IServiceType) => {
  return instance()
    .post<IServiceType>(`/serviceType/${serviceType.serviceTypeId}/update`, serviceType)
    .then((response) => response.data);
};

export const archiveServiceType = (serviceTypeId: number) => {
  return instance()
    .post('/serviceType/archive', { serviceTypeId })
    .then((response) => response.data);
};

export const recoverServiceType = (serviceTypeId: number) => {
  return instance()
    .post('/serviceType/recover', { serviceTypeId })
    .then((response) => response.data);
};

export const reorderServiceTypes = (serviceTypeIds: number[]) => {
  return instance()
    .post('/serviceType/serviceTypeOrder', { serviceTypeIds })
    .then((response) => response.data);
};
